import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaNewspaper, FaImages, FaFileAlt, FaPlus, FaCloudUploadAlt } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { API_BASE } from '../../config/api';

function AdminDashboard() {
  const { token } = useAuth();
  const [stats, setStats] = useState({ articles: 0, images: 0 });

  useEffect(() => {
    const safeJson = r => r.ok ? r.json() : Promise.resolve([]);
    Promise.all([
      fetch(`${API_BASE}/api/articles`).then(safeJson),
      fetch(`${API_BASE}/api/uploads`, { headers: { Authorization: `Bearer ${token}` } }).then(safeJson)
    ]).then(([articles, images]) => {
      setStats({
        articles: Array.isArray(articles) ? articles.length : 0,
        images: Array.isArray(images) ? images.length : 0
      });
    }).catch(() => {});
  }, [token]);

  const cards = [
    { label: 'Articles', count: stats.articles, link: '/admin/articles', color: '#32afe5', icon: <FaNewspaper /> },
    { label: 'Images', count: stats.images, link: '/admin/images', color: '#e5a532', icon: <FaImages /> },
    { label: 'Pages', count: '5', link: '/admin/site-content', color: '#32e5a5', icon: <FaFileAlt /> }
  ];

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1>Tableau de bord</h1>
          <p style={{ color: '#888', fontSize: '14px', marginTop: '4px' }}>
            Bienvenue dans l'espace d'administration RIVE
          </p>
        </div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: '20px',
        marginBottom: '32px'
      }}>
        {cards.map(card => (
          <Link
            key={card.label}
            to={card.link}
            className="admin-card stat-card"
            style={{ borderLeftColor: card.color }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div className="stat-label">{card.label}</div>
                <div className="stat-value">{card.count}</div>
              </div>
              <div style={{
                width: '44px', height: '44px', borderRadius: '10px',
                background: card.color + '15', color: card.color,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '18px'
              }}>
                {card.icon}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="admin-card">
        <h2 style={{ marginBottom: '16px', fontSize: '17px', color: '#1a1a2e', fontWeight: '600' }}>
          Actions rapides
        </h2>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Link to="/admin/articles/new" className="admin-btn admin-btn-primary">
            <FaPlus /> Nouvel article
          </Link>
          <Link to="/admin/images" className="admin-btn admin-btn-secondary" style={{ color: '#e5a532' }}>
            <FaCloudUploadAlt /> Uploader une image
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
